import React, { useState, useRef } from 'react'
import { useHistory } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import { useTheme } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Container from '@material-ui/core/Container'
import FilledInput from '@material-ui/core/FilledInput'
import FormControl from '@material-ui/core/FormControl'
import Grid from '@material-ui/core/Grid'
import { NotificationManager } from 'react-notifications'
import { Auth } from 'aws-amplify'
import { onError } from 'config/lib/errorLib'
import Loader from 'components/general/Loader'
import AuthHeader from 'components/argon/Headers/AuthHeader.js'
import ForgotPasswordModal from 'components/general/ForgotPasswordModal'
import componentStyles from 'assets/theme/views/auth/login.js'
import componentStylesButtons from 'assets/theme/components/button.js'

import eeLogo from 'resources/images/ee-logo.png'

const useStyles = makeStyles(componentStyles)
const useStylesButtons = makeStyles(componentStylesButtons)

function Login() {
    const history = useHistory()
    const classes = { ...useStyles(), ...useStylesButtons() }
    const theme = useTheme()
    const viewArea = useRef(null)

    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [showForgotPassword, setShowForgotPassword] = useState(false)
    const [confirmationCode, setConfirmationCode] = useState('')
    const [stage, setStage] = useState('login')
    const [loading, setLoading] = useState(false)

    const handleSubmit = (e) => {
        e.preventDefault()

        if (stage === 'login') {
            signIn()
        }
        else if (stage === 'confirmation') {
            confirmAccount()
        }
    }

    async function signIn() {
        setLoading(true)
        let formattedEmail = email.toLowerCase()
        try {
            const user = await Auth.signIn(formattedEmail, password)
            console.log('user: ', user)
            window.location.reload()
        } catch(e) {
            console.log(e)
            console.log(e.code)
            if (e.code === 'UserNotConfirmedException') {
                //NotificationManager.error('You must confirm your account in order to log in. Please check your email for a confirmation link')
                //TODO; change this to stage on login screen (for brokers)
                setStage('confirmation')
            }
            else if (e.code === 'UserNotFoundException') {
                NotificationManager.error('An account with this email has not yet been registered.')
            }
            else if (e.code === 'NotAuthorizedException') {
                NotificationManager.error('The email or password you have entered is incorrect')
            }
            else {
                onError(e)
            }
            setLoading(false)
        }
    }

    async function confirmAccount() {
        setLoading(true)
        let formattedEmail = email.trim().toLowerCase()
        if (confirmationCode.length > 0) {
            try {
                await Auth.confirmSignUp(formattedEmail, confirmationCode)
                //await api.sendWelcomeEmail(email)
                signIn()
            } catch(e) {
                console.log(e.code)
                if (e.code === 'CodeMismatchException') {
                    NotificationManager.error('Invalid code, please ensure you have entered the correct code')
                }
                onError(e)
            }
        }
        else {
            NotificationManager.error('Please enter the code that was sent to ' + formattedEmail)
        }
        setLoading(false)
    }

    async function resendCode() {
        let formattedEmail = email.trim().toLowerCase()
        try {
            await Auth.resendSignUp(formattedEmail)
            NotificationManager.success('Confirmation code sent to ' + formattedEmail)
        } catch(e) {
            console.log(e.code)
            onError(e)
        }
    }

    function openForgotPasswordModal(e) {
        e.preventDefault()
        setShowForgotPassword(true)
    }
   
    return (
        <>  
            <Grid container direction='row' justifyContent='center' alignItems='center' style={{width: '100%', padding: '1rem 3rem'}}>
                <Grid item xs={12} md={6} className='login-logo-container'>
                    <img className='login-logo' src={eeLogo} alt='logo' onClick={() => history.push('/login')} />
                </Grid>
                <Grid item xs={12} md={6}></Grid>
            </Grid>

            <Box ref={viewArea}></Box>

            {stage === 'login' &&
                <AuthHeader
                    title='Provider Login'
                    description='Manage your profile and billing'
                />
            }
            {stage === 'confirmation' &&
                <AuthHeader
                    title='Check your email'
                    description={'We just sent a confirmation code via email to ' + email}
                />
            }
          
            <Container
                component={Box}
                maxWidth='xl'
                marginTop='-12rem'
                paddingBottom='3rem'
                position='relative'
                zIndex='101'
            >
                {stage === 'login' &&
                    <form onSubmit={handleSubmit}>
                        <Box component={Grid} container justifyContent='center'>
                            <Grid item xs={12} lg={5} md={7}>
                                <Card classes={{ root: classes.cardRoot }} style={{backgroundColor: '#fff'}}>
                                    {/*<Button size='small' variant='contained' color='secondary' style={{width: '60px', margin: '0.5rem'}} onClick={() => setStage('select')}>Back</Button>*/}
                                    <CardContent classes={{ root: classes.cardContent }}>
                                        <Box
                                            color={theme.palette.gray[600]}
                                            textAlign='center'
                                            marginBottom='1rem'
                                            marginTop='.5rem'
                                            fontSize='1rem'
                                        >
                                            <p style={{ display: 'block' }}>
                                                <span style={{ color: theme.palette.gray[600] }}>
                                                    Don't have an account yet?{' '}
                                                </span>
                                                <span
                                                    style={{
                                                        color: theme.palette.primary.main,
                                                        textDecoration: 'underline',
                                                        cursor: 'pointer',
                                                        //fontWeight: 500
                                                    }}
                                                    onClick={() => history.push('/register')}
                                                >
                                                    Create an account
                                                </span>
                                            </p>
                                        </Box>

                                        <FormControl
                                            variant='filled'
                                            component={Box}
                                            width='100%'
                                            marginBottom='1rem!important'
                                        >
                                            <FilledInput
                                                autoComplete='off'
                                                type='email'
                                                placeholder='Email'
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                            />
                                        </FormControl>

                                        <FormControl
                                            variant='filled'
                                            component={Box}
                                            width='100%'
                                            marginBottom='1rem!important'
                                        >
                                            <FilledInput
                                                autoComplete='off'
                                                type='password'
                                                placeholder='Password'
                                                value={password}
                                                onChange={(e) => setPassword(e.target.value)}
                                            />
                                        </FormControl>
                                        
                                        <Box
                                            textAlign='center'
                                            marginTop='1.5rem'
                                            marginBottom='1.5rem'
                                        >
                                            <Button
                                                variant='contained'
                                                color='primary'
                                                //onClick={() => signIn()}
                                                type='submit'
                                                disabled={loading}
                                            >
                                                {!loading ? (
                                                    <>Sign in</>
                                                ) : (
                                                    <Loader height={12} />
                                                )}
                                            </Button>
                                        </Box>
                                    </CardContent>
                                </Card>
                                
                                <Grid container component={Box} marginTop='1rem'>
                                    <Grid item xs={12} component={Box} textAlign='center'>
                                        <p
                                            onClick={(e) => openForgotPasswordModal(e)}
                                            className='login-prompt'
                                        >
                                            Forgot password?
                                        </p>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Box>
                    </form>
                }
                {stage === 'confirmation' &&
                    <form onSubmit={handleSubmit}>
                        <Box component={Grid} container justifyContent='center'>
                            <Grid item xs={12} lg={6} md={8}>
                                <Card classes={{ root: classes.cardRoot }} style={{backgroundColor: '#fff'}}>
                                    <CardContent classes={{ root: classes.cardContent }}>
                                        <Box
                                            color={theme.palette.gray[600]}
                                            textAlign='center'
                                            marginBottom='1rem'
                                            marginTop='.5rem'
                                            fontSize='1rem'
                                        >
                                            <Box fontSize='80%' fontWeight='400' component='small'>
                                                Enter your confirmation code below
                                            </Box>
                                        </Box>

                                        <FormControl
                                            variant='filled'
                                            component={Box}
                                            width='100%'
                                            marginBottom='1rem!important'
                                        >
                                            <FilledInput
                                                autoComplete='off'
                                                type='email'
                                                placeholder='Email'
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                            />
                                        </FormControl>

                                        <FormControl
                                            variant='filled'
                                            component={Box}
                                            width='100%'
                                            marginBottom='1rem!important'
                                        >
                                            <FilledInput
                                                autoComplete='off'
                                                type='text'
                                                placeholder='Confirmation Code'
                                                value={confirmationCode}
                                                onChange={(e) => setConfirmationCode(e.target.value)}
                                            />
                                        </FormControl>
                                        
                                        <Box
                                            textAlign='center'
                                            marginTop='1.5rem'
                                            marginBottom='1.5rem'
                                        >
                                            <Button
                                                variant='contained'
                                                color='secondary'
                                                onClick={() => resendCode()}
                                                style={{marginRight: '1rem'}}
                                            >
                                                Resend Code
                                            </Button>
                                            <Button
                                                variant='contained'
                                                color='primary'
                                                type='submit'
                                                disabled={loading}
                                            >
                                                {!loading ? (
                                                    <>Confirm Account</>
                                                ) : (
                                                    <Loader height={12} />
                                                )}
                                            </Button>
                                        </Box>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Box>
                    </form>
                }

                {showForgotPassword &&
                    <ForgotPasswordModal 
                        isOpen={showForgotPassword}
                        close={() => setShowForgotPassword(false)}
                    />
                }
            </Container>
        </>
    )
}

export default Login